// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_8s-0";
export var headerCellHover = "_8s-1";
export var readCellContainer = "_8s-2";
export var readCellSlot = "_8s-3";
export var rowHoverCheckbox = "_8s-4";
export var rowUnreadIndicator = "_8s-5";
export var searchHighlight = "_8s-8";
export var supportTicketRow = "_8s-6";
export var unreadIndicator = "_8s-7";